<template>
  <v-app>
    <div class="card card-custom">
      <div class="card-body p-0">
        <div
            class="wizard wizard-2"
            id="kt_wizard_v2"
            data-wizard-state="step-first"
            data-wizard-clickable="true"
        >
          <div class="wizard-body py-8 px-8 py-lg-10 px-lg-10">
            <!--begin: Wizard Form-->
            <div class="row">
              <div class="col-md-8 col-sm-12 col-lg-8 col-xs-12">

                <h4>
                  {{ !edit ? "Add " : "Update" }} stock
                </h4>
                <router-link :to="{ name: 'dashboard' }">
                  Dashboard
                </router-link>
                \
                <router-link :to="{name:'inventory'}">
                  Inventory management
                </router-link>
                \
                {{ !edit ? "Add " : "Update" }} stock

              </div>

              <div class="col-md-4 col-sm-12 col-lg-4 col-xs-12 text-right">
                <!--                <router-link :to="{name:'book-create'}" class="btn btn-primary">-->
                <!--                  <i class="fas fa-plus"></i>-->
                <!--                  Add Book-->
                <!--                </router-link>-->
              </div>
            </div>
            <div class="row">
              <div class="col-12 form-group">
                <v-autocomplete label="Book" :items="books" item-text="title" item-value="id" name="" id="" outlined dense
                          v-model="inventory.book_id">
                </v-autocomplete>
                <span class="text-danger"
                      v-if="$v.inventory.book_id.$error">This information is required</span>
              </div>
              <div class="col-12 form-group">
                <v-text-field type="text" outlined dense label="Supplier name"
                              v-model="inventory.supplier"></v-text-field>
                <span class="text-danger"
                      v-if="$v.inventory.supplier.$error">This information is required</span>
              </div>
              <div class="col-12 form-group">
                <v-text-field type="text" outlined dense label="Invoice/order No."
                              v-model="inventory.bill_no"></v-text-field>
                <span class="text-danger"
                      v-if="$v.inventory.bill_no.$error">This information is required</span>
              </div>
              <div class="col-12 form-group">
                <v-text-field type="text" outlined dense label="Price" v-model="inventory.price"></v-text-field>
                <span class="text-danger"
                      v-if="$v.inventory.price.$error">This information is required</span>
              </div>
              <div class="col-12 form-group">
                <v-text-field type="text" outlined dense label="Total quantity"
                              v-model="inventory.total_qty"></v-text-field>
                <span class="text-danger"
                      v-if="$v.inventory.total_qty.$error">This information is required</span>
              </div>
              <div class="col-12 form-group">
                <v-menu
                    ref="menu1"
                    v-model="menu1"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="inventory.purchased_date"
                        label="Purchase date"
                        hint="MM/DD/YYYY format"
                        persistent-hint
                        prepend--inner-icon="mdi-calendar"
                        prepend-icon=""
                        v-bind="attrs"
                        @blur="date = parseDate(dateFormatted)"
                        v-on="on"
                        outlined
                        dense
                    ></v-text-field>
                  </template>
                  <v-date-picker
                      v-model="inventory.purchased_date"
                      no-title
                      @input="menu1 = false"
                  ></v-date-picker>
                </v-menu>
                <span class="text-danger" v-if=" $v.inventory.purchased_date.$error">This information is required</span>
              </div>
            </div>
            <div class="row">
              <div class="col-12 mt-5 text-right" v-if="checkIsAccessible('library-inventory', 'create')">
                <v-btn
                    class="text-white btn btn-primary btn   font-weight-bold px-9 py-4 my-3 font-size-3 mx-4"
                    depressed
                    @click="createOrUpdate"
                    :loading="isBusy"
                >Save
                </v-btn>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </v-app>
</template>

<script>
import InventoryService from "@/core/services/library/inventory/InventoryService";
import BookService from "@/core/services/library/book/BookService";

import {required} from "vuelidate/lib/validators";

const bookService = new BookService();

const inventory = new InventoryService();
export default {
  name: "inventory-create-or-update",
  validations() {
    return {
      inventory: this.inventory_rule,
    }
  },
  data() {
    return {
      menu1: false,
      edit: false,
      isBusy: false,
      books: [],
      inventory: {
        'bill_no': null,
        'supplier': null,
        'book_id': null,
        'total_qty': null,
        'price': null,
        'purchased_date': null,
      }
    }
  }, computed: {
    inventory_id() {
      return this.$route.params.id
    },
    inventory_rule() {
      let rules = {
        'bill_no': {required},
        'supplier': {required},
        'purchased_date': {required},
        'book_id': {required},
        'total_qty': {required},
        'price': {required},
      }
      return rules;
    }
  }, mounted() {
    this.getBooks()
    if (this.inventory_id) {
      this.getInventory();
    }
  },
  methods: {
    getBooks() {
      bookService
          .getActive()
          .then(response => {
              this.books = response.data.books
          })
      },
    getInventory() {
      inventory.show(this.inventory_id).then(response => {
        this.inventory = response.data.inventory
        this.edit = true
      })
    },
    createOrUpdate() {
      this.$v.$touch();
      if (this.$v.$error) {
        setTimeout(() => {
          this.$v.$reset();
        }, 3000)
      } else {
        if (this.edit) {
          this.update()
        } else {
          this.create()
        }
      }

    }, create() {
      inventory.store(this.inventory).then(response => {
        this.$snotify.success("Inventory created")
        this.redirect()
      })
    }, update() {
      inventory.update(this.inventory_id, this.inventory).then(response => {
        this.$snotify.success("Inventory updated")
        this.redirect()
      })
    }, redirect() {
      this.$router.push({name: "inventory"})
    }
  }
}
</script>

<style scoped>

</style>
